// google-maps-demo.component.ts
import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, ViewChild, ViewEncapsulation} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DecimalPipe, DOCUMENT, NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { GMapService } from 'app/services/gmap.service';
import { Istanza, IstanzeService } from 'app/services/istanze.service';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { UserService } from 'app/core/user/user.service';

export interface Position {
    id?: number;
    lat: number;
    lng: number;
    codice_interno?:string;
}

interface GMapProps extends FormlyFieldProps {

    id?: number;
    lat: number;
    lng: number;
    codice_interno?:string;
    maxsize: number;
    count: number;

}


@Component({
  selector: 'g-map-sv',
  templateUrl: 'g-map-sv.component.html',
  styleUrl: 'g-map-sv.component.scss',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, ReactiveFormsModule, FormsModule, MatIconModule, DecimalPipe]
})
export class GoogleMapSVTypeComponent extends FieldType<FieldTypeConfig<GMapProps>> implements AfterViewInit{

    @ViewChild('gmap') mapDiv: ElementRef;
    @ViewChild('gpano') panDiv: ElementRef;
    @ViewChild('layers') layerDiv: ElementRef;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _fuseMediaWatcherService = inject(FuseMediaWatcherService);
    private _document: Document = inject(DOCUMENT);

    private _userService = inject(UserService);
    private _istanzeService = inject(IstanzeService);
    private _mapService = inject(GMapService);


    posizione: Position;
    tipo: string;

    gMap:google.maps.Map;
    marker: google.maps.marker.AdvancedMarkerElement


    editMode: boolean = false;
    baseMap: string;
    BaseMaps: any;

    checkLayers:boolean[];

    layerStatus:any;

    wmsLayers: any;

    layers:any[]=[];


    status = 'out';

    over() {
      console.log('Mouseover called');
      this.status = 'over';
    }

    out() {
      console.log('Mouseout called');
      this.status = 'out';
    }




    ngOnInit(): void {

        console.log(this.field.props);

        this.BaseMaps = this._mapService.BaseMaps;
        this.baseMap = this._mapService.baseMapId;

        this.wmsLayers = this._mapService.wmsLayers;
        this.layerStatus = this._mapService.layerStatus;

        this. _istanzeService.istanza$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((istanza:Istanza) =>{

            console.log(istanza)

            this.posizione = {id: 1, lat:44.12440, lng: 9.7911960, codice_interno: istanza.codice}

            //this.setEditMode()


        })






    }

    ngAfterViewInit(): void {

        this._mapService.initMap(this.mapDiv.nativeElement, {
            center: { lat: this.posizione.lat, lng: this.posizione.lng },
            zoom: 15
        }).then((map)=>{
            this.gMap = map;
            this._mapService.addStreetView(this.panDiv.nativeElement, map);
            this.marker = this._mapService.mapMarker;
            this.marker.addListener('dragend', (event) => {
                const position = this.marker.position
                console.log(position)
            });


        }).catch((err)=>console.log(err))

    }

    setBaseMap(base: any){
        this._mapService.setBaseMap(base)
    }





    setOverlay(){
        this._mapService.layerStatus = this.layerStatus
        this._mapService.setOverlays()
    }



    center:any;
    display:any;

    moveMap(event: google.maps.MapMouseEvent) {
      if (event.latLng){
        this.center = event.latLng.toJSON();
        console.log(this.center)
      }
    }

    move(event: google.maps.MapMouseEvent) {
      if (event.latLng){
        this.display = event.latLng && event.latLng.toJSON();
        console.log(this.display)
      }
    }

    setEditMode(){
        this.editMode=true;
        this.marker.gmpDraggable=true
    }

    savePosition(){
        //this._mapService.updatePosition(this.marker.getPosition())
        const newPosition = {id: this.posizione.id, lat: this.marker.position.lat, lng: this.marker.position.lng}

        console.log(newPosition)



    }

    cancelPosition(){
        this.marker.position= this.gMap.getCenter();
        this.editMode = false;
    }


}
